import { IMiddlewareEvent } from 'mobx-state-tree';

import { getCompanyDomain } from '@src/helpers';
import { fetchRequestActionRegExp, requestActionRegExp } from '@src/constants';

const companyId = getCompanyDomain();

const callback = async (request, innerCallback) => {
  try {
    await request;
  } finally {
    // we need to go deeper
    innerCallback();
  }
};

export const modifyRequestArgsMiddleware = (action: IMiddlewareEvent, next) => {
  const isFetchRequestAction = fetchRequestActionRegExp.test(action.name);
  const isRequestAction = requestActionRegExp.test(action.name);

  if (action.type === 'action' && (isFetchRequestAction || isRequestAction)) {
    action.args[0] = {
      ...(action.args[0] || {}),
      companyId
    };

    if (isFetchRequestAction) {
      action.args[1] = {
        ...(action.args[1] || {}),
        cancelToken: action.context.getCancelToken()
      };
      action.context.incrementPendingCalls();
      return next(action, request => callback(request, action.context.decrementPendingCalls));
    }
  }
  next(action);
};
